import { render, staticRenderFns } from "./ProfileAsideMenu.vue?vue&type=template&id=6e1aac49&scoped=true&"
import script from "./ProfileAsideMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileAsideMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAsideMenu.vue?vue&type=style&index=0&id=6e1aac49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1aac49",
  null
  
)

export default component.exports